import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { GlobalContext } from '../../context/global.context'

// --- Importing other components ---
import ProfileListPopup from './ProfileListPopup'
import ProfileDetails from './ProfileDetails'

const MultiProfile = () => {
    const [, setTheme] = useState(null)
    // const { profileManagementThemes = {} } = useSelector(store => store.profileManagement)
    const { profileManagementConfig = {}, profileManagementThemes = {} } = useSelector(store => store.profileManagement)
    const { showMultiProfileList, showProfileDetails } = useContext(GlobalContext)
    const isMultiProfileEnabled = Object.keys(profileManagementConfig).length > 0

    // --Setting Profile Theme---
    useEffect(() => {
        setTheme(profileManagementThemes.profileTheme)
    }, [profileManagementThemes])

    if (!isMultiProfileEnabled) return null

    return (
        <MultiProfileWrapper>
            {showMultiProfileList && <ProfileListPopup />}
            {showProfileDetails.flag && <ProfileDetails />}
        </MultiProfileWrapper>
    )
}

const MultiProfileWrapper = styled.div`
.toast{
    border: 2px solid #ffd200;
    border-radius: 5px;
}
`

export default MultiProfile